<template>
  <div class="index-stock full-height">
    <div class="bg-white p-y-15 p-x-24 border-radius-12 full-height">
      <div class="font-14 flex-s-0 m-b-24">门店分布</div>
      <tk-flex class="">
        <div class="">
          <div class="font-14">{{ user.adminRole === 'staff' ? '大区数' : '战区数' }}</div>
          <div class="font-16 font-bold">{{ theatersNum }}</div>
        </div>
        <div style="marginLeft: 40px" >
          <div class="font-14">门店数</div>
          <div class="font-16 font-bold">{{ storesNum }}</div>
        </div>
      </tk-flex>
      <div ref="store" style="width: 100%;" :style="{ height: `calc(100% - 100px)` }"></div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      theatersNum: 0,
      storesNum: 0,
      // 按战区分组
      theatersList: [],
      colors: ['#F6313F', '#060A13', '#158DFC', '#26D49B', '#857AFF', '#FFCF44', '#FE7145', '#38C963', '#DB74FF', '#FF6161'],
      colorList: [],
      datas: []
    }
  },
  computed: {
    ...mapState(['user'])
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      try {
        this.colors = this.generateRandomColorArray(30)
        // promise.all 并发请求· 优化请求速度
        await Promise.all([this.getGroupStores(), this.getStoresAll()])
        await this.getStorePercent()
      } catch (error) {
        console.log(error)
      }
    },
    /// 获取颜色随机数组
    generateRandomColorArray (length) {
      const colorArray = []
      for (let i = 0; i < length; i++) {
        let color = this.getRandomColor()
        while (color === '#000000') {
          color = this.getRandomColor()
        }
        colorArray.push(color)
      }
      return colorArray
    },
    getRandomColor () {
      const letters = '0123456789ABCDEF'
      let color = '#'
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },
    // 获取按战区/大区统计门店
    async getGroupStores () {
      let { data: res } = await this.$tkParse.get('/aggregate/store', {
        params: {
          group: {
            objectId: this.user.adminRole === 'staff' ? '$regional' : '$warZone',
            total: {
              $sum: 1
            }
          },
          match: {
            ...{ isDelete: false },
            ...this.user.adminRole === 'staff' ? { warZone: this.user.department } : {}
          }
        }
      })
      // console.log('🚀 ~ file: stock.vue:147 ~ getInStock ~ res', res.results)
      this.theatersList = res.results
    },
    // 获取门店总数
    async getStoresAll () {
      let { data: res } = await this.$tkParse.get('/aggregate/store', {
        params: {
          group: {
            objectId: '',
            total: {
              $sum: 1
            }
          },
          match: {
            ...{ isDelete: false },
            ...this.user.adminRole === 'staff' ? { warZone: this.user.department } : {}
          }
        }
      })
      // console.log('🚀 ~ file: stock.vue:147 ~ getInStock ~ res', res.results)
      this.storesNum = res.results && res.results.length ? res.results[0].total || 0 : 0
    },
    /// 获取战区/大区数计算百分比
    async getStorePercent () {
      let { data: { results: res } } = await this.$tkParse.get('/classes/department', {
        params: {
          limit: 1000,
          where: {
            ...(this.user.adminRole === 'staff' ? {
              level: '2',
              parentNode: this.user.department
            } : { level: '1' }),
            ...{
              isDelete: {
                $ne: true
              }
            }
          }
        }
      })
      var data = []
      var colors = []
      for (let index = 0; index < res.length; index++) {
        const element = res[index]
        let findIndex = this.theatersList.findIndex((item) => item.objectId === element.objectId)
        data.push({
          name: element.name,
          value: findIndex === -1 ? 0 : (this.theatersList[findIndex] ? this.theatersList[findIndex].total : 0)
        })
        colors.push(this.colors[index % 10])
      }
      this.theatersNum = res.length
      this.datas = data
      this.colorList = colors
      // 绘制图表
      this.$nextTick(() => {
        this.initChart()
      })
      // this.initChart()
    },
    async initChart () {
      let mychart = this.$echarts.init(this.$refs.store)
      mychart.setOption({
        tooltip: {
          trigger: 'item'
        },
        // 图例
        legend: [
          {
            selectedMode: true, // 图例选择的模式，控制是否可以通过点击图例改变系列的显示状态。默认开启图例选择，可以设成 false 关闭。
            bottom: '0%',
            left: 'center',
            textStyle: {
              // 图例的公用文本样式。
              fontSize: 12,
              color: '#363B45'
            },
            formatter: (name) => {
              var tarValue = 0
              for (var i = 0; i < this.datas.length; i++) {
                if (this.datas[i].name === name) {
                  tarValue = this.datas[i].value
                }
              }
              var v = tarValue
              return name + ' ' + v
            }
          }
        ],
        // 系列列表
        series: [
          {
            name: '门店数',
            type: 'pie',
            radius: ['35%', '55%'],
            center: ['50%', '30%'], // 饼图的中心（圆心）坐标，数组的第一项是横坐标，第二项是纵坐标。[ default: ['50%', '50%'] ]
            avoidLabelOverlap: false,
            emphasis: {
              label: {
                show: true,
                fontSize: '14',
                fontWeight: 'bold'
              },
              formatter: (name) => {
                var tarValue = 0
                for (var i = 0; i < this.datas.length; i++) {
                  if (this.datas[i].name === name) {
                    tarValue = this.datas[i].value
                  }
                }
                var v = tarValue
                return name + ' ' + v
              }
            },
            labelLine: {
              show: false
            },
            label: {
              normal: {
                show: false,
                formatter: '{d}%\n{b}',
                position: 'center',
                lineHight: 35
              }
            },
            color: this.colorList, // 圆环图的颜色
            data: this.datas
          }
        ],
        grid: { // 让图表占满容器
          top: '0px',
          left: '0px',
          right: '0px',
          bottom: '0px'
        }
      })

      // 自动渲染echarts
      window.addEventListener('resize', () => {
        mychart.resize()
      })
    }
  }
}
</script>
<style scoped lang="scss">
.a {
  color: #FF6161;
}
</style>
